<template>
  <el-dialog
    class="modal config-new"
    :title="DialogTitle"
    :visible="DialogVisible"
    :close-on-click-modal="false"
    @close="$emit('close', false)"
    width="500px"
  >
    <div class="dialog-title" slot="title">
      <i class="el-icon-folder-add" style="font-size: 24px;"></i>
      {{DialogTitle}}
    </div>
    <div class="config-new-main">
      <div class="form-row">
        <div class="form-row-label">{{ $t('projectSite') }}<span class="require">*</span></div>
        <div class="form-row-content">
          <el-input class="content-input" v-model="project.site" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-row-label">{{ $t('projectNote') }}</div>
        <div class="form-row-content">
          <el-input class="content-input" v-model="project.descr" />
        </div>
      </div>
      <div class="form-row slot">
        <div class="form-row-label">{{ $t('projectPanelsList') }}</div>
        <div class="form-row-content">
            <editTable :tableData="tableData" :type='type'></editTable>
        </div>
      </div>
      <div class="form-row slot">
        <div class="form-row-label">{{ $t('projectPanelMode') }}</div>
        <div class="form-row-content" style="margin-top: 20px;">
          <el-radio class="content-input" v-model="project.panelType" :label="0">{{ $t('projectPanelTypeSingle') }}</el-radio>
          <el-radio class="content-input" v-model="project.panelType" :label="1">{{ $t('projectPanelTypeNetwork') }}</el-radio>
        </div>
      </div>
    </div>
    <div class="config-new-button">
      <el-button class="gray-btn"  @click="$emit('close', false)">{{ $t('cancel') }}</el-button>
      <el-button class="blue-btn" :loading="loading" @click="saveData">{{ $t('sure') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
/* eslint-disable */
import editTable from '../../components/editTable.vue'
import { projectNew, projectUpdate, } from '../../api/config'
import Cookies from 'js-cookie'
import config from '../../common/config'

export default {
  name: 'projectDialog',
  props: {
    DialogTitle: {
      type: String,
      default: ''
    },
    DialogVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'new'
    },
    data: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  components: {
    editTable
  },
  data () {
    return {
      project: {
        site: '',
        descr: '',
        panels: [],
        panelType:0,
        loadingText: this.$t('globalLoadingText')
      },
      tableData:{
        // 选中行   
        sel: null,
        row: { "panelNo": "0", "descr": "", "isSet": true, "panelNo_disabled": false, }, //新增行数据
        tHead: [
          { id: "panelNo", name: this.$t('projectInfoPanelTheadPanelNo'), show: true, type: 'input', placeholder: "登录用户", },
          { id: "descr", name: this.$t('projectInfoPanelTheaddesc'), show: true, type: 'input', placeholder: "登录密码", },
        ]  ,
        tBody: [
          { panelNo: '0', descr: '' , isSet:false}
        ],
        addShow: false
      },
      ajax_mathods: projectNew,
      loading:false,
    }
  },
  mounted () {
    if(this.type == 'edit'){
      this.project = this.deepClone(this.data);
      this.tableData.tBody = this.deepClone(this.data.panels);
      this.ajax_mathods = projectUpdate;
    }
  },
  methods: {
    saveData () {
      let arr = []
      for(let index in this.tableData.tBody){
        let item = this.tableData.tBody[index]
        if(index!==0 && item.isSet){
          this.$message.warning(this.$t('editTableError'))
          return;
        }
        // 注释可为空，by:bqx ,2020.2.24 18:50
        if(item.panelNo !== ''){
          arr.push(item)
        }
      }
      if(!this.project.site){
          this.$message.warning(this.$t('projectAddRequired'))
          return
      }
      if(arr.length){
        this.project.panels = this.deepClone(arr);
      }
      this.project.userId = Cookies.get(config.userId)
      this.loading = true;
      this.ajax_mathods(this.project).then(res=>{
        this.loading = false;
        if(res.code == 1){
          this.$message.success(this.type=='edit'?this.$t('projectEditSuccess'):this.$t('projectNewSuccess'));
          this.project.site = '';
          this.project.descr = '';
          this.project.panels = [];
          if(this.tableData.tBody[0].panelNo){
            this.tableData.tBody[0].panelNo = '';
          }
          if(this.tableData.tBody[0].descr){
            this.tableData.tBody[0].descr = '';
          }
          this.$emit('close', false)
          if(this.type == 'edit'){
            this.$parent.newDialog = false;
          }
          // xinjianxiangmuyoukongzhiqi新建项目有控制器跳转
          if(this.type == 'new' &&  res.data.panels && res.data.panels.length){
            // this.$emit('goRouter', res.data.panels)
            this.$emit('goRouter', res.data)
          }
        }
      }).catch(err=>{
        this.loading = false;
        this.$emit('close', false)
      })
    },
    deepClone (obj) {
    // 判断原对象是否存在
      if (obj) {
        var newObj = JSON.parse(JSON.stringify(obj));
        return newObj;
      }
    }
  },
  watch: {
    DialogVisible () {},
    data:{
      handler(){
        this.project = this.deepClone(this.data);
        this.tableData.tBody = this.deepClone(this.data.panels);
        this.ajax_mathods = projectUpdate;
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.config-new {
    width: 100%;
    height: 100%;
    .config-new-main {
        width: 100%;
        .form-row {
            border-bottom: 1px solid #CCDEEE;
            margin: 0 auto;
            margin-top: 35px;
            vertical-align: top;
            width: calc(100% - 100px);
            .form-row-label {
                font-size: 16px;
                .require{
                  color: red;
                }
            }
            .form-row-content {
                /deep/ .content-input{
                  border: none;
                  .el-input__inner{
                      border: none;
                  }
              }
            }
        }
        .slot{
            border:0;
        }
    }
    .config-new-button {
        margin-top: 20px;
        text-align: right;
    }
}
</style>
